import React from 'react';
import Login from './Login';

const Register = () => {
  return (
    <>
      <Login type='register' />
    </>
  );
};

export default Register;
